import { FC } from 'react'

import { SimpleModal, Center } from '@sequencehq/core-components'
import Spinner from 'components/Loading'

import { MODAL_BASE_PROPS } from './PublishQuoteModalV2.constants'

/**
 * Shown while we work out which of the other variants this quote gets - the
 * quote still saving, or the simulation still running. Both flows use it, so
 * the wait looks the same whether signatures are on or not.
 */
export const ModalLoading: FC = () => {
  return (
    <SimpleModal
      {...MODAL_BASE_PROPS}
      onClose={() => false}
      showSubmitButton={false}
      showCancelButton={false}
      data-testid="modal.publishQuote.loading"
    >
      <Center height="226px">
        <Spinner />
      </Center>
    </SimpleModal>
  )
}
